import { render, staticRenderFns } from "./BindingDoctorsModal.vue?vue&type=template&id=9e8ea0a6&scoped=true&"
import script from "./BindingDoctorsModal.vue?vue&type=script&lang=js&"
export * from "./BindingDoctorsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e8ea0a6",
  null
  
)

export default component.exports